import { handleMaintenance } from '@declaration/services/handleMaintenance';
import { isAxiosError } from '@shared/utils/errors';
const middleware = async ({ store }) => {
    var _a;
    try {
        await Promise.all([
            store.dispatch('settings/fetchSettingsIfNotSet'),
            store.dispatch('helpers/fetch'),
            store.dispatch('externalDamage/fetchTypes'),
            store.dispatch('personalProperty/fetchCategories'),
            store.dispatch('roomDamage/fetchCoveringCategoriesIfNotSet'),
            store.dispatch('thirdParty/fetchInsuranceCompanyChoicesIfNotSet'),
        ]);
        // Le backend avait été injoignable lors d'une précédente navigation mais
        // répond de nouveau (settings inclus) : on sort de l'écran de maintenance
        // pour laisser claimFetched recharger normalement la déclaration.
        if (store.getters['pages/isInMaintenance'] && store.getters['settings/areSettingsFetched']) {
            store.dispatch('pages/selectActiveStep', null);
        }
    }
    catch (error) {
        // Un 401 est déjà géré par l'intercepteur Axios (redirection vers /login) :
        // on ne bascule sur l'écran de maintenance que pour une erreur réseau ou un 503.
        if (isAxiosError(error) && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
            return;
        }
        handleMaintenance(store);
    }
};
export default middleware;
